import React, { useState } from "react";
import { Link } from "react-router-dom";
import classes from './Header.module.css';


const Header = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const toggleMenu = () => setMenuAbierto(!menuAbierto);

  return (
    <header className={classes.header}>
      <div className={classes.logo}>
        <h1>Kraken Media</h1>
      </div>
      
      <button className={classes["menu-toggle"]} onClick={toggleMenu}>
        ☰
      </button>

      <nav className={`${menuAbierto ? classes.show : ""}`}>
        <Link to="/inicio">Inicio</Link>
        <Link to="/quienes-somos">¿Quienes somos?</Link>
        <Link to="/productos">Portafolio</Link>
        <Link to="/contacto" className={classes.botonContacto}>Contacto</Link>
      </nav>
    </header>
  );
};

export default Header;